import Image from 'next/image'
import styled, { css } from 'styled-components'

import Icon from '../Icon'
import Video from '../Video'

export const Media = styled.div<{ $clickable?: boolean }>`
  background-color: ${({ theme }) => theme.colors.altoGray};
  width: 100%;
  height: 12rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  ${({ $clickable }) =>
    $clickable &&
    css`
      cursor: pointer;
    `};
`

export const Preview = styled(Image)`
  object-fit: cover;
  height: 100%;
`

export const PreviewVideo = styled(Video)`
  height: 12rem;
`

export const DocIcon = styled(Icon).attrs({ icon: 'doc' })``
export const YoutubeIcon = styled(Icon).attrs({ icon: 'socialYoutube' })``
export const ImageIcon = styled(Icon).attrs({ icon: 'upload' })``
export const DeleteIcon = styled(Icon).attrs({ icon: 'delete' })``
export const EditIcon = styled(Icon).attrs({ icon: 'edit' })``

export const Button = styled.button`
  background: none;
  border: none;
`

export const Separator = styled.span`
  width: 1px;
  background-color: ${({ theme }) => theme.colors.blueBack};
  height: 1.5rem;
  margin: 0 1rem;
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 0.5rem;
`

export const Wrapper = styled.div``
